import session from './session'

export default {
  getSubscription() {
    return session.get('/api/subscriptions/')
  },
}
